import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'components/Button';
import { useGetParticipantsDownload } from 'components/Participants/gql/useGetParticipantsDownload';
import { PrintParticipants } from 'components/Participants/PrintParticipants';
import useNewPurchase from 'hooks/useNewPurchase';
import PermissionModal from 'pages/track/PermissionModal/PermissionModal';
import { AppContext } from 'shared/AppContext';
import Export from './export';

const HeaderButtons = ({ event, date }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const isSpectatorList = pathname.includes('spectatorsList');

  const { data, subscribeToMore } = useGetParticipantsDownload();
  useNewPurchase({ subscribeToMore }, event.id, '', date);

  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const {
    state: { capabilities },
  } = useContext(AppContext);

  const userType = pathname.split('/').includes('admin-employee')
    ? 'employee'
    : 'track';

  if (!data || !data.getParticipantsList) return null;

  const participants = data.getParticipantsList;

  const handleClickScan = (id, date) => {
    pathname.includes('/admin-track/') || pathname.includes('/admin-employee/')
      ? history.push(`/admin-${userType}/scan/${id}?date=${date}`)
      : history.push(`/admin/scan/${id}?date=${date}`);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Button
        buttonStyle={{ width: 165, marginRight: 10 }}
        onClick={
          !capabilities ||
          capabilities.length === 0 ||
          capabilities?.scan_tickets
            ? () => handleClickScan(event.id, date)
            : () => setShowPermissionModal(true)
        }
      >
        {process.env.REACT_APP_PLATFORM !== 'tickethoss'
          ? 'SCAN PARTICIPANTS'
          : 'SCAN TICKETS'}
      </Button>

      {isSpectatorList && (
        <>
          <Export participants={participants} event={event} />

          <PrintParticipants
            refunded={participants
              .map((item) => (item.status === 'refunded' ? item.name : null))
              .filter(Boolean)}
            checkedIn={participants
              .map((item) => {
                const tickets = item.tickets.filter(
                  (ticket) => ticket.is_checked && 'active' === ticket.status
                );
                return tickets.length === item.tickets.length
                  ? item.name
                  : null;
              })
              .filter(Boolean)}
            participants={participants}
            date={date}
            eventID={event.id}
            event={event}
          />
        </>
      )}

      <PermissionModal
        isVisible={showPermissionModal}
        hideModal={() => setShowPermissionModal(false)}
        link={`/admin-${userType}/settings/1`}
        history={history}
      />
    </div>
  );
};

export default HeaderButtons;
